import { render, staticRenderFns } from "./PagePrice.vue?vue&type=template&id=9c8aed8e&scoped=true&"
import script from "./PagePrice.vue?vue&type=script&lang=js&"
export * from "./PagePrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c8aed8e",
  null
  
)

export default component.exports